// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { utc } from 'moment';
import Dropdown from '@localytics/loc-components/lib/Dropdown';
import type OrchestrationVersion from '../constants/ApiActionTypes';
import { VERSION_STATE_MAP } from '../constants/ApiTypes';
import './stylesheets/CampaignVersionPicker.scss';

type Props = {
  orchestrationVersions: { [number]: OrchestrationVersion },
  orchestrationVersionId: number,
  createOrchestrationVersion: Function,
  getOrchestrationVersion: Function,
  orgId: number,
  orchestrationId: number,
  history: Object,
  creatives: Array<any> // FIXME
};

type Option = {
  label: string,
  value: number
};

type State = {
  selectedValue: Option | null
};

const getOrchVersionOption: Function = version => {
  if (!version) return null;
  const label = `${VERSION_STATE_MAP[version.state]} ${version.version_number}`;
  const value = version.id;
  return { label, value, className: `${version.state}` };
};

class CampaignVersionPicker extends Component<Props, State> {
  state = {
    selectedValue: getOrchVersionOption(
      this.props.orchestrationVersions &&
        this.props.orchestrationVersions[this.props.orchestrationVersionId]
    )
  };

  setValue: Function = (option: { label: string, value: number }) => {
    const {
      orgId,
      orchestrationVersions: {
        [this.props.orchestrationVersionId]: version
      } = {},
      history,
      creatives,
      orchestrationId,
      createOrchestrationVersion
    } = this.props;
    if (option.label === 'New Draft') {
      createOrchestrationVersion(history, orgId, version, creatives);
    } else {
      this.setState({ selectedValue: option });
      this.props.getOrchestrationVersion(orgId, orchestrationId, option.value);
      this.props.history.replace(
        `/show?orgId=${orgId}&orchId=${orchestrationId}&versionId=${
          option.value
        }`
      );
    }
  };

  render() {
    const { orchestrationVersions, orchestrationVersionId } = this.props;
    const { selectedValue } = this.state;
    let options = null;
    let selected = null;
    if (orchestrationVersions) {
      options = Object.keys(orchestrationVersions)
        .map(key => orchestrationVersions[+key])
        .sort((versionA, versionB) => {
          const { updated_at: updatedA, created_at: createdA } = versionA;
          const { updated_at: updatedB, created_at: createdB } = versionB;
          const timeA = utc(updatedA || createdA);
          const timeB = utc(updatedB || createdB);
          if (timeA.isAfter(timeB)) {
            return -1;
          } else if (timeB.isAfter(timeA)) {
            return 1;
          }
          return 0;
        })
        .map(vers => getOrchVersionOption(vers));
      options.unshift({ label: 'New Draft', value: null, className: 'new' });
      selected = options.find(o => {
        if (selectedValue) {
          return selectedValue && selectedValue.value === o.value;
        }
        return o.value === +orchestrationVersionId;
      });
    }

    return (
      <div className="CampaignVersionPicker">
        <Dropdown
          name="CampaignVersions"
          options={options}
          selectedValue={selected}
          onSelect={this.setValue}
          clearable={false}
          className="CampaignVersionPicker__Dropdown"
        />
      </div>
    );
  }
}

export default withRouter(CampaignVersionPicker);



// WEBPACK FOOTER //
// ./src/components/CampaignVersionPicker.jsx